<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <!-- <el-button type="text">导出数据</el-button> -->
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <el-carousel
        ref="carousel"
        indicator-position="none"
        arrow="never"
        height="100%"
        :loop="false"
        :autoplay="false"
      >
        <el-carousel-item
          v-for="question in questionList"
          :key="question.questionId"
        >
          <component
            :is="question.type"
            :question="question"
            :idx="activeIdx"
            @update='getList'
          ></component>
        </el-carousel-item>
      </el-carousel>
      <div class="btns">
        <el-button
          v-show="activeIdx > 1"
          class="btn"
          type="primary"
          @click="
            activeIdx--;
            $refs.carousel.prev();
          "
          >上一题
        </el-button>
        <el-button
          v-show="activeIdx < questionList.length"
          class="btn"
          type="primary"
          @click="
            activeIdx++;
            $refs.carousel.next();
          "
        >
          下一题</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import RADIO from "./components/radio";
import CHECKBOX from "./components/checkbox";
import BOOLEAN from "./components/boolean";
import SUPPLY from "./components/supply";
import ANSWER from "./components/answer";
import mixinsData from "../mixins/detail";
import { quizList } from "@/api/activity/quiz";
import { formatDate } from "@/utils/index";
export default {
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
  },
  mixins: [mixinsData],
  data() {
    return {
      formatDate,
      activeIdx: 1,
      questionList: [],
    };
  },
  methods: {
    getList() {
      let activityId = this.$route.query.activityId;
      quizList({ activityId }).then((res) => {
        if (res.code == 0) {
          this.questionList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}

.main {
  height: calc(100% - 30px - 20px - 93px - 30px);
  background-color: #fff;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }
  ::v-deep .el-carousel {
    height: calc(100% - 70px);
  }
  .btns {
    .btn {
      margin: 0 15px;
      width: 144px;
      height: 42px;
      font-size: 16px;
      border-radius: 10px;
      box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>